import React from 'react';
import {useDispatch} from 'react-redux';
import {findContactDetails} from '../../../../../../../../../../../../../../../../../actions/contactDetailsActions';
import Button from '../../../../../../../../../../../../../../../../components/button';

function CommentsButton ({contactId, contactType, title, disabled}) {

	const dispatch = useDispatch();

	const handleClick = () => {
		dispatch(findContactDetails(contactId, contactType));

		setTimeout(() => {
			if(document.getElementById('writeNewComment')){
				document.getElementById('writeNewComment').focus();
			}
		}, 500)
	};

	return (
		<Button
			className="btn-link"
			title={title || ''}
			data-contact-id={contactId}
			data-contact-type={contactType}
			onClick={ handleClick }
			disabled={disabled}
		>
			<div className="more-option-item__picto">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
					<path
						fill="currentColor"
						d="M 0 14.666 L 0 12.001 L 9.334 12.001 L 9.334 14.666 L 0 14.666 Z M 0 9.333 L 0 6.666 L 14.667 6.666 L 14.667 9.333 L 0 9.333 Z M 0 4 L 0 1.334 L 14.667 1.334 L 14.667 4 L 0 4 Z M 12.001 22.666 L 12.001 18.566 L 19.367 11.233 C 19.566 11.033 19.789 10.888 20.034 10.801 C 20.279 10.712 20.524 10.667 20.767 10.667 C 21.034 10.667 21.29 10.717 21.534 10.816 C 21.778 10.917 22.001 11.067 22.2 11.267 L 23.434 12.501 C 23.612 12.701 23.751 12.922 23.85 13.167 C 23.952 13.41 24 13.655 24 13.9 C 24 14.145 23.956 14.394 23.868 14.649 C 23.777 14.906 23.633 15.133 23.434 15.335 L 16.099 22.666 L 12.001 22.666 Z M 22.001 13.9 L 20.767 12.667 L 22.001 13.9 Z M 14.001 20.667 L 15.267 20.667 L 19.3 16.6 L 18.701 15.967 L 18.068 15.366 L 14.001 19.4 L 14.001 20.667 Z M 18.701 15.967 L 18.068 15.366 L 19.3 16.6 L 18.701 15.967 Z"
					/>
				</svg>
			</div>
			<div className="more-option-item__text">
				<span>{title}</span>
			</div>
		</Button>
	)
}

export default CommentsButton;
